import type { LucideIcon } from 'lucide-react'
import { ChevronDown, ChevronRight } from 'lucide-react'
import type * as React from 'react'

interface AnalysisTileCollapsibleSectionProps {
	icon: LucideIcon
	title: string
	countLabel: string
	open: boolean
	onToggle: () => void
	children: React.ReactNode
}

function AnalysisTileCollapsibleSection({
	icon: Icon,
	title,
	countLabel,
	open,
	onToggle,
	children,
}: AnalysisTileCollapsibleSectionProps) {
	return (
		<div className="mt-3 rounded-lg border border-[#8c52ff]/35 bg-background p-3">
			<button
				type="button"
				className="flex w-full items-center gap-2 text-left"
				aria-expanded={open}
				onClick={(e) => {
					e.stopPropagation()
					onToggle()
				}}
			>
				{open ? (
					<ChevronDown className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
				) : (
					<ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
				)}
				<Icon className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
				<span className="text-xs font-semibold uppercase tracking-wide text-foreground/80">
					{title}
				</span>
				{!open && (
					<span className="ml-auto text-xs font-normal text-muted-foreground">{countLabel}</span>
				)}
			</button>
			{open && <div className="mt-2.5 flex flex-wrap gap-2">{children}</div>}
		</div>
	)
}

export { AnalysisTileCollapsibleSection }
